// @ts-nocheck
/* eslint-disable */
// Generated from ./src/antlr/ManimLexer.g4 by ANTLR 4.7.3-SNAPSHOT


import { ATN } from "antlr4ts/atn/ATN";
import { ATNDeserializer } from "antlr4ts/atn/ATNDeserializer";
import { CharStream } from "antlr4ts/CharStream";
import { Lexer } from "antlr4ts/Lexer";
import { LexerATNSimulator } from "antlr4ts/atn/LexerATNSimulator";
import { NotNull } from "antlr4ts/Decorators";
import { Override } from "antlr4ts/Decorators";
import { RuleContext } from "antlr4ts/RuleContext";
import { Vocabulary } from "antlr4ts/Vocabulary";
import { VocabularyImpl } from "antlr4ts/VocabularyImpl";

import * as Utils from "antlr4ts/misc/Utils";


export class ManimLexer extends Lexer {
	public static readonly WHITESPACE = 1;
	public static readonly SEMI = 2;
	public static readonly COLON = 3;
	public static readonly DOT = 4;
	public static readonly EQUAL = 5;
	public static readonly COMMA = 6;
	public static readonly AT = 7;
	public static readonly TRUE = 8;
	public static readonly FALSE = 9;
	public static readonly ADD = 10;
	public static readonly MINUS = 11;
	public static readonly TIMES = 12;
	public static readonly DIVIDE = 13;
	public static readonly LT = 14;
	public static readonly GT = 15;
	public static readonly GE = 16;
	public static readonly LE = 17;
	public static readonly EQ = 18;
	public static readonly NEQ = 19;
	public static readonly AND = 20;
	public static readonly OR = 21;
	public static readonly NOT = 22;
	public static readonly OPEN_PARENTHESIS = 23;
	public static readonly CLOSE_PARENTHESIS = 24;
	public static readonly OPEN_CURLY_BRACKET = 25;
	public static readonly CLOSE_CURLY_BRACKET = 26;
	public static readonly OPEN_SQUARE_BRACKET = 27;
	public static readonly CLOSE_SQUARE_BRACKET = 28;
	public static readonly CODE_COMMENT = 29;
	public static readonly LET = 30;
	public static readonly FUN = 31;
	public static readonly RETURN = 32;
	public static readonly NUMBER_TYPE = 33;
	public static readonly BOOL_TYPE = 34;
	public static readonly CHAR_TYPE = 35;
	public static readonly STRING_TYPE = 36;
	public static readonly COMMENT = 37;
	public static readonly SLEEP = 38;
	public static readonly STACK = 39;
	public static readonly ARRAY = 40;
	public static readonly LIST = 41;
	public static readonly TREE = 42;
	public static readonly TREE_NODE = 43;
	public static readonly IF = 44;
	public static readonly ELSE = 45;
	public static readonly WHILE = 46;
	public static readonly FOR = 47;
	public static readonly IN = 48;
	public static readonly RANGE = 49;
	public static readonly BREAK = 50;
	public static readonly CONTINUE = 51;
	public static readonly TO_NUMBER = 52;
	public static readonly TO_CHAR = 53;
	public static readonly STEP_INTO = 54;
	public static readonly STEP_OVER = 55;
	public static readonly SPEED = 56;
	public static readonly SUBTITLE = 57;
	public static readonly SUBTITLE_ONCE = 58;
	public static readonly NULL = 59;
	public static readonly IDENT = 60;
	public static readonly NUMBER = 61;
	public static readonly STRING = 62;
	public static readonly CHAR_LITER = 63;

	// tslint:disable:no-trailing-whitespace
	public static readonly channelNames: string[] = [
		"DEFAULT_TOKEN_CHANNEL", "HIDDEN",
	];

	// tslint:disable:no-trailing-whitespace
	public static readonly modeNames: string[] = [
		"DEFAULT_MODE",
	];

	public static readonly ruleNames: string[] = [
		"WHITESPACE", "SEMI", "COLON", "DOT", "EQUAL", "COMMA", "AT", "TRUE", 
		"FALSE", "ADD", "MINUS", "TIMES", "DIVIDE", "LT", "GT", "GE", "LE", "EQ", 
		"NEQ", "AND", "OR", "NOT", "OPEN_PARENTHESIS", "CLOSE_PARENTHESIS", "OPEN_CURLY_BRACKET", 
		"CLOSE_CURLY_BRACKET", "OPEN_SQUARE_BRACKET", "CLOSE_SQUARE_BRACKET", 
		"CODE_COMMENT", "LET", "FUN", "RETURN", "NUMBER_TYPE", "BOOL_TYPE", "CHAR_TYPE", 
		"STRING_TYPE", "COMMENT", "SLEEP", "STACK", "ARRAY", "LIST", "TREE", "TREE_NODE", 
		"IF", "ELSE", "WHILE", "FOR", "IN", "RANGE", "BREAK", "CONTINUE", "TO_NUMBER", 
		"TO_CHAR", "STEP_INTO", "STEP_OVER", "SPEED", "SUBTITLE", "SUBTITLE_ONCE", 
		"NULL", "IDENT", "DIGIT", "NUMBER", "ESCAPED_CHAR", "CHARACTER", "STRING", 
		"CHAR_LITER",
	];

	private static readonly _LITERAL_NAMES: Array<string | undefined> = [
		undefined, undefined, "';'", "':'", "'.'", "'='", "','", "'@'", "'true'", 
		"'false'", "'+'", "'-'", "'*'", "'/'", "'<'", "'>'", "'>='", "'<='", "'=='", 
		"'!='", "'&&'", "'||'", "'!'", "'('", "')'", "'{'", "'}'", "'['", "']'", 
		undefined, "'let'", "'fun'", "'return'", "'number'", "'boolean'", "'char'", 
		"'string'", "'comment'", "'sleep'", "'Stack'", "'Array'", "'List'", "'Tree'", 
		"'Node'", "'if'", "'else'", "'while'", "'for'", "'in'", "'range'", "'break'", 
		"'continue'", "'toNumber'", "'toChar'", "'@stepInto'", "'@stepOver'", 
		"'@speed'", "'@subtitle'", "'@subtitleOnce'", "'null'",
	];
	private static readonly _SYMBOLIC_NAMES: Array<string | undefined> = [
		undefined, "WHITESPACE", "SEMI", "COLON", "DOT", "EQUAL", "COMMA", "AT", 
		"TRUE", "FALSE", "ADD", "MINUS", "TIMES", "DIVIDE", "LT", "GT", "GE", 
		"LE", "EQ", "NEQ", "AND", "OR", "NOT", "OPEN_PARENTHESIS", "CLOSE_PARENTHESIS", 
		"OPEN_CURLY_BRACKET", "CLOSE_CURLY_BRACKET", "OPEN_SQUARE_BRACKET", "CLOSE_SQUARE_BRACKET", 
		"CODE_COMMENT", "LET", "FUN", "RETURN", "NUMBER_TYPE", "BOOL_TYPE", "CHAR_TYPE", 
		"STRING_TYPE", "COMMENT", "SLEEP", "STACK", "ARRAY", "LIST", "TREE", "TREE_NODE", 
		"IF", "ELSE", "WHILE", "FOR", "IN", "RANGE", "BREAK", "CONTINUE", "TO_NUMBER", 
		"TO_CHAR", "STEP_INTO", "STEP_OVER", "SPEED", "SUBTITLE", "SUBTITLE_ONCE", 
		"NULL", "IDENT", "NUMBER", "STRING", "CHAR_LITER",
	];
	public static readonly VOCABULARY: Vocabulary = new VocabularyImpl(ManimLexer._LITERAL_NAMES, ManimLexer._SYMBOLIC_NAMES, []);

	// @Override
	// @NotNull
	public get vocabulary(): Vocabulary {
		return ManimLexer.VOCABULARY;
	}
	// tslint:enable:no-trailing-whitespace


	constructor(input: CharStream) {
		super(input);
		this._interp = new LexerATNSimulator(ManimLexer._ATN, this);
	}

	// @Override
	public get grammarFileName(): string { return "ManimLexer.g4"; }

	// @Override
	public get ruleNames(): string[] { return ManimLexer.ruleNames; }

	// @Override
	public get serializedATN(): string { return ManimLexer._serializedATN; }

	// @Override
	public get channelNames(): string[] { return ManimLexer.channelNames; }

	// @Override
	public get modeNames(): string[] { return ManimLexer.modeNames; }

	public static readonly _serializedATN: string =
		"\x03\uC91D\uCABA\u058D\uAFBA\u4F53\u0607\uEA8B\uC241\x02A\u01C9\b\x01" +
		"\x04\x02\t\x02\x04\x03\t\x03\x04\x04\t\x04\x04\x05\t\x05\x04\x06\t\x06" +
		"\x04\x07\t\x07\x04\b\t\b\x04\t\t\t\x04\n\t\n\x04\v\t\v\x04\f\t\f\x04\r" +
		"\t\r\x04\x0E\t\x0E\x04\x0F\t\x0F\x04\x10\t\x10\x04\x11\t\x11\x04\x12\t" +
		"\x12\x04\x13\t\x13\x04\x14\t\x14\x04\x15\t\x15\x04\x16\t\x16\x04\x17\t" +
		"\x17\x04\x18\t\x18\x04\x19\t\x19\x04\x1A\t\x1A\x04\x1B\t\x1B\x04\x1C\t" +
		"\x1C\x04\x1D\t\x1D\x04\x1E\t\x1E\x04\x1F\t\x1F\x04 \t \x04!\t!\x04\"\t" +
		"\"\x04#\t#\x04$\t$\x04%\t%\x04&\t&\x04\'\t\'\x04(\t(\x04)\t)\x04*\t*\x04" +
		"+\t+\x04,\t,\x04-\t-\x04.\t.\x04/\t/\x040\t0\x041\t1\x042\t2\x043\t3\x04" +
		"4\t4\x045\t5\x046\t6\x047\t7\x048\t8\x049\t9\x04:\t:\x04;\t;\x04<\t<\x04" +
		"=\t=\x04>\t>\x04?\t?\x04@\t@\x04A\tA\x04B\tB\x04C\tC\x03\x02\x03\x02\x03" +
		"\x02\x03\x02\x03\x03\x03\x03\x03\x04\x03\x04\x03\x05\x03\x05\x03\x06\x03" +
		"\x06\x03\x07\x03\x07\x03\b\x03\b\x03\t\x03\t\x03\t\x03\t\x03\t\x03\n\x03" +
		"\n\x03\n\x03\n\x03\n\x03\n\x03\v\x03\v\x03\f\x03\f\x03\r\x03\r\x03\x0E" +
		"\x03\x0E\x03\x0F\x03\x0F\x03\x10\x03\x10\x03\x11\x03\x11\x03\x11\x03\x12" +
		"\x03\x12\x03\x12\x03\x13\x03\x13\x03\x13\x03\x14\x03\x14\x03\x14\x03\x15" +
		"\x03\x15\x03\x15\x03\x16\x03\x16\x03\x16\x03\x17\x03\x17\x03\x18\x03\x18" +
		"\x03\x19\x03\x19\x03\x1A\x03\x1A\x03\x1B\x03\x1B\x03\x1C\x03\x1C\x03\x1D" +
		"\x03\x1D\x03\x1E\x03\x1E\x07\x1E\xD1\n\x1E\f\x1E\x0E\x1E\xD4\v\x1E\x03" +
		"\x1E\x05\x1E\xD7\n\x1E\x03\x1E\x03\x1E\x03\x1F\x03\x1F\x03\x1F\x03\x1F" +
		"\x03 \x03 \x03 \x03 \x03!\x03!\x03!\x03!\x03!\x03!\x03!\x03\"\x03\"\x03" +
		"\"\x03\"\x03\"\x03\"\x03\"\x03#\x03#\x03#\x03#\x03#\x03#\x03#\x03#\x03" +
		"$\x03$\x03$\x03$\x03$\x03%\x03%\x03%\x03%\x03%\x03%\x03%\x03&\x03&\x03" +
		"&\x03&\x03&\x03&\x03&\x03&\x03\'\x03\'\x03\'\x03\'\x03\'\x03\'\x03(\x03" +
		"(\x03(\x03(\x03(\x03(\x03)\x03)\x03)\x03)\x03)\x03)\x03*\x03*\x03*\x03" +
		"*\x03*\x03+\x03+\x03+\x03+\x03+\x03,\x03,\x03,\x03,\x03,\x03-\x03-\x03" +
		"-\x03.\x03.\x03.\x03.\x03.\x03/\x03/\x03/\x03/\x03/\x03/\x030\x030\x03" +
		"0\x030\x031\x031\x031\x032\x032\x032\x032\x032\x032\x033\x033\x033\x03" +
		"3\x033\x033\x034\x034\x034\x034\x034\x034\x034\x034\x034\x035\x035\x03" +
		"5\x035\x035\x035\x035\x035\x035\x036\x036\x036\x036\x036\x036\x036\x03" +
		"7\x037\x037\x037\x037\x037\x037\x037\x037\x037\x038\x038\x038\x038\x03" +
		"8\x038\x038\x038\x038\x038\x039\x039\x039\x039\x039\x039\x039\x03:\x03" +
		":\x03:\x03:\x03:\x03:\x03:\x03:\x03:\x03:\x03;\x03;\x03;\x03;\x03;\x03" +
		";\x03;\x03;\x03;\x03;\x03;\x03;\x03;\x03;\x03<\x03<\x03<\x03<\x03<\x03" +
		"=\x03=\x07=\u01A2\n=\f=\x0E=\u01A5\v=\x03>\x03>\x03?\x06?\u01AA\n?\r?" +
		"\x0E?\u01AB\x03?\x03?\x06?\u01B0\n?\r?\x0E?\u01B1\x05?\u01B4\n?\x03@\x03" +
		"@\x03A\x03A\x03A\x05A\u01BB\nA\x03B\x03B\x07B\u01BF\nB\fB\x0EB\u01C2\v" +
		"B\x03B\x03B\x03C\x03C\x03C\x03C\x02\x02\x02D\x03\x02\x03\x05\x02\x04\x07" +
		"\x02\x05\t\x02\x06\v\x02\x07\r\x02\b\x0F\x02\t\x11\x02\n\x13\x02\v\x15" +
		"\x02\f\x17\x02\r\x19\x02\x0E\x1B\x02\x0F\x1D\x02\x10\x1F\x02\x11!\x02" +
		"\x12#\x02\x13%\x02\x14\'\x02\x15)\x02\x16+\x02\x17-\x02\x18/\x02\x191" +
		"\x02\x1A3\x02\x1B5\x02\x1C7\x02\x1D9\x02\x1E;\x02\x1F=\x02 ?\x02!A\x02" +
		"\"C\x02#E\x02$G\x02%I\x02&K\x02\'M\x02(O\x02)Q\x02*S\x02+U\x02,W\x02-" +
		"Y\x02.[\x02/]\x020_\x021a\x022c\x023e\x024g\x025i\x026k\x027m\x028o\x02" +
		"9q\x02:s\x02;u\x02<w\x02=y\x02>{\x02\x02}\x02?\x7F\x02\x02\x81\x02\x02" +
		"\x83\x02@\x85\x02A\x03\x02\b\x05\x02\v\f\x0F\x0F\"\"\x04\x02\f\f\x0F\x0F" +
		"\x04\x02C\\c|\x06\x022;C\\aac|\v\x02$$))22^^ddhhppttvv\x05\x02$$))^^\x02" +
		"\u01CD\x02\x03\x03\x02\x02\x02\x02\x05\x03\x02\x02\x02\x02\x07\x03\x02" +
		"\x02\x02\x02\t\x03\x02\x02\x02\x02\v\x03\x02\x02\x02\x02\r\x03\x02\x02" +
		"\x02\x02\x0F\x03\x02\x02\x02\x02\x11\x03\x02\x02\x02\x02\x13\x03\x02\x02" +
		"\x02\x02\x15\x03\x02\x02\x02\x02\x17\x03\x02\x02\x02\x02\x19\x03\x02\x02" +
		"\x02\x02\x1B\x03\x02\x02\x02\x02\x1D\x03\x02\x02\x02\x02\x1F\x03\x02\x02" +
		"\x02\x02!\x03\x02\x02\x02\x02#\x03\x02\x02\x02\x02%\x03\x02\x02\x02\x02" +
		"\'\x03\x02\x02\x02\x02)\x03\x02\x02\x02\x02+\x03\x02\x02\x02\x02-\x03" +
		"\x02\x02\x02\x02/\x03\x02\x02\x02\x021\x03\x02\x02\x02\x023\x03\x02\x02" +
		"\x02\x025\x03\x02\x02\x02\x027\x03\x02\x02\x02\x029\x03\x02\x02\x02\x02" +
		";\x03\x02\x02\x02\x02=\x03\x02\x02\x02\x02?\x03\x02\x02\x02\x02A\x03\x02" +
		"\x02\x02\x02C\x03\x02\x02\x02\x02E\x03\x02\x02\x02\x02G\x03\x02\x02\x02" +
		"\x02I\x03\x02\x02\x02\x02K\x03\x02\x02\x02\x02M\x03\x02\x02\x02\x02O\x03" +
		"\x02\x02\x02\x02Q\x03\x02\x02\x02\x02S\x03\x02\x02\x02\x02U\x03\x02\x02" +
		"\x02\x02W\x03\x02\x02\x02\x02Y\x03\x02\x02\x02\x02[\x03\x02\x02\x02\x02" +
		"]\x03\x02\x02\x02\x02_\x03\x02\x02\x02\x02a\x03\x02\x02\x02\x02c\x03\x02" +
		"\x02\x02\x02e\x03\x02\x02\x02\x02g\x03\x02\x02\x02\x02i\x03\x02\x02\x02" +
		"\x02k\x03\x02\x02\x02\x02m\x03\x02\x02\x02\x02o\x03\x02\x02\x02\x02q\x03" +
		"\x02\x02\x02\x02s\x03\x02\x02\x02\x02u\x03\x02\x02\x02\x02w\x03\x02\x02" +
		"\x02\x02y\x03\x02\x02\x02\x02}\x03\x02\x02\x02\x02\x83\x03\x02\x02\x02" +
		"\x02\x85\x03\x02\x02\x02\x03\x87\x03\x02\x02\x02\x05\x8B\x03\x02\x02\x02" +
		"\x07\x8D\x03\x02\x02\x02\t\x8F\x03\x02\x02\x02\v\x91\x03\x02\x02\x02\r" +
		"\x93\x03\x02\x02\x02\x0F\x95\x03\x02\x02\x02\x11\x97\x03\x02\x02\x02\x13" +
		"\x9C\x03\x02\x02\x02\x15\xA2\x03\x02\x02\x02\x17\xA4\x03\x02\x02\x02\x19" +
		"\xA6\x03\x02\x02\x02\x1B\xA8\x03\x02\x02\x02\x1D\xAA\x03\x02\x02\x02\x1F" +
		"\xAC\x03\x02\x02\x02!\xAE\x03\x02\x02\x02#\xB1\x03\x02\x02\x02%\xB4\x03" +
		"\x02\x02\x02\'\xB7\x03\x02\x02\x02)\xBA\x03\x02\x02\x02+\xBD\x03\x02\x02" +
		"\x02-\xC0\x03\x02\x02\x02/\xC2\x03\x02\x02\x021\xC4\x03\x02\x02\x023\xC6" +
		"\x03\x02\x02\x025\xC8\x03\x02\x02\x027\xCA\x03\x02\x02\x029\xCC\x03\x02" +
		"\x02\x02;\xCE\x03\x02\x02\x02=\xDA\x03\x02\x02\x02?\xDE\x03\x02\x02\x02" +
		"A\xE2\x03\x02\x02\x02C\xE9\x03\x02\x02\x02E\xF0\x03\x02\x02\x02G\xF8\x03" +
		"\x02\x02\x02I\xFD\x03\x02\x02\x02K\u0104\x03\x02\x02\x02M\u010C\x03\x02" +
		"\x02\x02O\u0112\x03\x02\x02\x02Q\u0118\x03\x02\x02\x02S\u011E\x03\x02" +
		"\x02\x02U\u0123\x03\x02\x02\x02W\u0128\x03\x02\x02\x02Y\u012D\x03\x02" +
		"\x02\x02[\u0130\x03\x02\x02\x02]\u0135\x03\x02\x02\x02_\u013B\x03\x02" +
		"\x02\x02a\u013F\x03\x02\x02\x02c\u0142\x03\x02\x02\x02e\u0148\x03\x02" +
		"\x02\x02g\u014E\x03\x02\x02\x02i\u0157\x03\x02\x02\x02k\u0160\x03\x02" +
		"\x02\x02m\u0167\x03\x02\x02\x02o\u0171\x03\x02\x02\x02q\u017B\x03\x02" +
		"\x02\x02s\u0182\x03\x02\x02\x02u\u018C\x03\x02\x02\x02w\u019A\x03\x02" +
		"\x02\x02y\u019F\x03\x02\x02\x02{\u01A6\x03\x02\x02\x02}\u01A9\x03\x02" +
		"\x02\x02\x7F\u01B5\x03\x02\x02\x02\x81\u01BA\x03\x02\x02\x02\x83\u01BC" +
		"\x03\x02\x02\x02\x85\u01C5\x03\x02\x02\x02\x87\x88\t\x02\x02\x02\x88\x89" +
		"\x03\x02\x02\x02\x89\x8A\b\x02\x02\x02\x8A\x04\x03\x02\x02\x02\x8B\x8C" +
		"\x07=\x02\x02\x8C\x06\x03\x02\x02\x02\x8D\x8E\x07<\x02\x02\x8E\b\x03\x02" +
		"\x02\x02\x8F\x90\x070\x02\x02\x90\n\x03\x02\x02\x02\x91\x92\x07?\x02\x02" +
		"\x92\f\x03\x02\x02\x02\x93\x94\x07.\x02\x02\x94\x0E\x03\x02\x02\x02\x95" +
		"\x96\x07B\x02\x02\x96\x10\x03\x02\x02\x02\x97\x98\x07v\x02\x02\x98\x99" +
		"\x07t\x02\x02\x99\x9A\x07w\x02\x02\x9A\x9B\x07g\x02\x02\x9B\x12\x03\x02" +
		"\x02\x02\x9C\x9D\x07h\x02\x02\x9D\x9E\x07c\x02\x02\x9E\x9F\x07n\x02\x02" +
		"\x9F\xA0\x07u\x02\x02\xA0\xA1\x07g\x02\x02\xA1\x14\x03\x02\x02\x02\xA2" +
		"\xA3\x07-\x02\x02\xA3\x16\x03\x02\x02\x02\xA4\xA5\x07/\x02\x02\xA5\x18" +
		"\x03\x02\x02\x02\xA6\xA7\x07,\x02\x02\xA7\x1A\x03\x02\x02\x02\xA8\xA9" +
		"\x071\x02\x02\xA9\x1C\x03\x02\x02\x02\xAA\xAB\x07>\x02\x02\xAB\x1E\x03" +
		"\x02\x02\x02\xAC\xAD\x07@\x02\x02\xAD \x03\x02\x02\x02\xAE\xAF\x07@\x02" +
		"\x02\xAF\xB0\x07?\x02\x02\xB0\"\x03\x02\x02\x02\xB1\xB2\x07>\x02\x02\xB2" +
		"\xB3\x07?\x02\x02\xB3$\x03\x02\x02\x02\xB4\xB5\x07?\x02\x02\xB5\xB6\x07" +
		"?\x02\x02\xB6&\x03\x02\x02\x02\xB7\xB8\x07#\x02\x02\xB8\xB9\x07?\x02\x02" +
		"\xB9(\x03\x02\x02\x02\xBA\xBB\x07(\x02\x02\xBB\xBC\x07(\x02\x02\xBC*\x03" +
		"\x02\x02\x02\xBD\xBE\x07~\x02\x02\xBE\xBF\x07~\x02\x02\xBF,\x03\x02\x02" +
		"\x02\xC0\xC1\x07#\x02\x02\xC1.\x03\x02\x02\x02\xC2\xC3\x07*\x02\x02\xC3" +
		"0\x03\x02\x02\x02\xC4\xC5\x07+\x02\x02\xC52\x03\x02\x02\x02\xC6\xC7\x07" +
		"}\x02\x02\xC74\x03\x02\x02\x02\xC8\xC9\x07\x7F\x02\x02\xC96\x03\x02\x02" +
		"\x02\xCA\xCB\x07]\x02\x02\xCB8\x03\x02\x02\x02\xCC\xCD\x07_\x02\x02\xCD" +
		":\x03\x02\x02\x02\xCE\xD2\x07%\x02\x02\xCF\xD1\n\x03\x02\x02\xD0\xCF\x03" +
		"\x02\x02\x02\xD1\xD4\x03\x02\x02\x02\xD2\xD0\x03\x02\x02\x02\xD2\xD3\x03" +
		"\x02\x02\x02\xD3\xD6\x03\x02\x02\x02\xD4\xD2\x03\x02\x02\x02\xD5\xD7\t" +
		"\x03\x02\x02\xD6\xD5\x03\x02\x02\x02\xD6\xD7\x03\x02\x02\x02\xD7\xD8\x03" +
		"\x02\x02\x02\xD8\xD9\b\x1E\x02\x02\xD9<\x03\x02\x02\x02\xDA\xDB\x07n\x02" +
		"\x02\xDB\xDC\x07g\x02\x02\xDC\xDD\x07v\x02\x02\xDD>\x03\x02\x02\x02\xDE" +
		"\xDF\x07h\x02\x02\xDF\xE0\x07w\x02\x02\xE0\xE1\x07p\x02\x02\xE1@\x03\x02" +
		"\x02\x02\xE2\xE3\x07t\x02\x02\xE3\xE4\x07g\x02\x02\xE4\xE5\x07v\x02\x02" +
		"\xE5\xE6\x07w\x02\x02\xE6\xE7\x07t\x02\x02\xE7\xE8\x07p\x02\x02\xE8B\x03" +
		"\x02\x02\x02\xE9\xEA\x07p\x02\x02\xEA\xEB\x07w\x02\x02\xEB\xEC\x07o\x02" +
		"\x02\xEC\xED\x07d\x02\x02\xED\xEE\x07g\x02\x02\xEE\xEF\x07t\x02\x02\xEF" +
		"D\x03\x02\x02\x02\xF0\xF1\x07d\x02\x02\xF1\xF2\x07q\x02\x02\xF2\xF3\x07" +
		"q\x02\x02\xF3\xF4\x07n\x02\x02\xF4\xF5\x07g\x02\x02\xF5\xF6\x07c\x02\x02" +
		"\xF6\xF7\x07p\x02\x02\xF7F\x03\x02\x02\x02\xF8\xF9\x07e\x02\x02\xF9\xFA" +
		"\x07j\x02\x02\xFA\xFB\x07c\x02\x02\xFB\xFC\x07t\x02\x02\xFCH\x03\x02\x02" +
		"\x02\xFD\xFE\x07u\x02\x02\xFE\xFF\x07v\x02\x02\xFF\u0100\x07t\x02\x02" +
		"\u0100\u0101\x07k\x02\x02\u0101\u0102\x07p\x02\x02\u0102\u0103\x07i\x02" +
		"\x02\u0103J\x03\x02\x02\x02\u0104\u0105\x07e\x02\x02\u0105\u0106\x07q" +
		"\x02\x02\u0106\u0107\x07o\x02\x02\u0107\u0108\x07o\x02\x02\u0108\u0109" +
		"\x07g\x02\x02\u0109\u010A\x07p\x02\x02\u010A\u010B\x07v\x02\x02\u010B" +
		"L\x03\x02\x02\x02\u010C\u010D\x07u\x02\x02\u010D\u010E\x07n\x02\x02\u010E" +
		"\u010F\x07g\x02\x02\u010F\u0110\x07g\x02\x02\u0110\u0111\x07r\x02\x02" +
		"\u0111N\x03\x02\x02\x02\u0112\u0113\x07U\x02\x02\u0113\u0114\x07v\x02" +
		"\x02\u0114\u0115\x07c\x02\x02\u0115\u0116\x07e\x02\x02\u0116\u0117\x07" +
		"m\x02\x02\u0117P\x03\x02\x02\x02\u0118\u0119\x07C\x02\x02\u0119\u011A" +
		"\x07t\x02\x02\u011A\u011B\x07t\x02\x02\u011B\u011C\x07c\x02\x02\u011C" +
		"\u011D\x07{\x02\x02\u011DR\x03\x02\x02\x02\u011E\u011F\x07N\x02\x02\u011F" +
		"\u0120\x07k\x02\x02\u0120\u0121\x07u\x02\x02\u0121\u0122\x07v\x02\x02" +
		"\u0122T\x03\x02\x02\x02\u0123\u0124\x07V\x02\x02\u0124\u0125\x07t\x02" +
		"\x02\u0125\u0126\x07g\x02\x02\u0126\u0127\x07g\x02\x02\u0127V\x03\x02" +
		"\x02\x02\u0128\u0129\x07P\x02\x02\u0129\u012A\x07q\x02\x02\u012A\u012B" +
		"\x07f\x02\x02\u012B\u012C\x07g\x02\x02\u012CX\x03\x02\x02\x02\u012D\u012E" +
		"\x07k\x02\x02\u012E\u012F\x07h\x02\x02\u012FZ\x03\x02\x02\x02\u0130\u0131" +
		"\x07g\x02\x02\u0131\u0132\x07n\x02\x02\u0132\u0133\x07u\x02\x02\u0133" +
		"\u0134\x07g\x02\x02\u0134\\\x03\x02\x02\x02\u0135\u0136\x07y\x02\x02\u0136" +
		"\u0137\x07j\x02\x02\u0137\u0138\x07k\x02\x02\u0138\u0139\x07n\x02\x02" +
		"\u0139\u013A\x07g\x02\x02\u013A^\x03\x02\x02\x02\u013B\u013C\x07h\x02" +
		"\x02\u013C\u013D\x07q\x02\x02\u013D\u013E\x07t\x02\x02\u013E`\x03\x02" +
		"\x02\x02\u013F\u0140\x07k\x02\x02\u0140\u0141\x07p\x02\x02\u0141b\x03" +
		"\x02\x02\x02\u0142\u0143\x07t\x02\x02\u0143\u0144\x07c\x02\x02\u0144\u0145" +
		"\x07p\x02\x02\u0145\u0146\x07i\x02\x02\u0146\u0147\x07g\x02\x02\u0147" +
		"d\x03\x02\x02\x02\u0148\u0149\x07d\x02\x02\u0149\u014A\x07t\x02\x02\u014A" +
		"\u014B\x07g\x02\x02\u014B\u014C\x07c\x02\x02\u014C\u014D\x07m\x02\x02" +
		"\u014Df\x03\x02\x02\x02\u014E\u014F\x07e\x02\x02\u014F\u0150\x07q\x02" +
		"\x02\u0150\u0151\x07p\x02\x02\u0151\u0152\x07v\x02\x02\u0152\u0153\x07" +
		"k\x02\x02\u0153\u0154\x07p\x02\x02\u0154\u0155\x07w\x02\x02\u0155\u0156" +
		"\x07g\x02\x02\u0156h\x03\x02\x02\x02\u0157\u0158\x07v\x02\x02\u0158\u0159" +
		"\x07q\x02\x02\u0159\u015A\x07P\x02\x02\u015A\u015B\x07w\x02\x02\u015B" +
		"\u015C\x07o\x02\x02\u015C\u015D\x07d\x02\x02\u015D\u015E\x07g\x02\x02" +
		"\u015E\u015F\x07t\x02\x02\u015Fj\x03\x02\x02\x02\u0160\u0161\x07v\x02" +
		"\x02\u0161\u0162\x07q\x02\x02\u0162\u0163\x07E\x02\x02\u0163\u0164\x07" +
		"j\x02\x02\u0164\u0165\x07c\x02\x02\u0165\u0166\x07t\x02\x02\u0166l\x03" +
		"\x02\x02\x02\u0167\u0168\x07B\x02\x02\u0168\u0169\x07u\x02\x02\u0169\u016A" +
		"\x07v\x02\x02\u016A\u016B\x07g\x02\x02\u016B\u016C\x07r\x02\x02\u016C" +
		"\u016D\x07K\x02\x02\u016D\u016E\x07p\x02\x02\u016E\u016F\x07v\x02\x02" +
		"\u016F\u0170\x07q\x02\x02\u0170n\x03\x02\x02\x02\u0171\u0172\x07B\x02" +
		"\x02\u0172\u0173\x07u\x02\x02\u0173\u0174\x07v\x02\x02\u0174\u0175\x07" +
		"g\x02\x02\u0175\u0176\x07r\x02\x02\u0176\u0177\x07Q\x02\x02\u0177\u0178" +
		"\x07x\x02\x02\u0178\u0179\x07g\x02\x02\u0179\u017A\x07t\x02\x02\u017A" +
		"p\x03\x02\x02\x02\u017B\u017C\x07B\x02\x02\u017C\u017D\x07u\x02\x02\u017D" +
		"\u017E\x07r\x02\x02\u017E\u017F\x07g\x02\x02\u017F\u0180\x07g\x02\x02" +
		"\u0180\u0181\x07f\x02\x02\u0181r\x03\x02\x02\x02\u0182\u0183\x07B\x02" +
		"\x02\u0183\u0184\x07u\x02\x02\u0184\u0185\x07w\x02\x02\u0185\u0186\x07" +
		"d\x02\x02\u0186\u0187\x07v\x02\x02\u0187\u0188\x07k\x02\x02\u0188\u0189" +
		"\x07v\x02\x02\u0189\u018A\x07n\x02\x02\u018A\u018B\x07g\x02\x02\u018B" +
		"t\x03\x02\x02\x02\u018C\u018D\x07B\x02\x02\u018D\u018E\x07u\x02\x02\u018E" +
		"\u018F\x07w\x02\x02\u018F\u0190\x07d\x02\x02\u0190\u0191\x07v\x02\x02" +
		"\u0191\u0192\x07k\x02\x02\u0192\u0193\x07v\x02\x02\u0193\u0194\x07n\x02" +
		"\x02\u0194\u0195\x07g\x02\x02\u0195\u0196\x07Q\x02\x02\u0196\u0197\x07" +
		"p\x02\x02\u0197\u0198\x07e\x02\x02\u0198\u0199\x07g\x02\x02\u0199v\x03" +
		"\x02\x02\x02\u019A\u019B\x07p\x02\x02\u019B\u019C\x07w\x02\x02\u019C\u019D" +
		"\x07n\x02\x02\u019D\u019E\x07n\x02\x02\u019Ex\x03\x02\x02\x02\u019F\u01A3" +
		"\t\x04\x02\x02\u01A0\u01A2\t\x05\x02\x02\u01A1\u01A0\x03\x02\x02\x02\u01A2" +
		"\u01A5\x03\x02\x02\x02\u01A3\u01A1\x03\x02\x02\x02\u01A3\u01A4\x03\x02" +
		"\x02\x02\u01A4z\x03\x02\x02\x02\u01A5\u01A3\x03\x02\x02\x02\u01A6\u01A7" +
		"\x042;\x02\u01A7|\x03\x02\x02\x02\u01A8\u01AA\x05{>\x02\u01A9\u01A8\x03" +
		"\x02\x02\x02\u01AA\u01AB\x03\x02\x02\x02\u01AB\u01A9\x03\x02\x02\x02\u01AB" +
		"\u01AC\x03\x02\x02\x02\u01AC\u01B3\x03\x02\x02\x02\u01AD\u01AF\x05\t\x05" +
		"\x02\u01AE\u01B0\x05{>\x02\u01AF\u01AE\x03\x02\x02\x02\u01B0\u01B1\x03" +
		"\x02\x02\x02\u01B1\u01AF\x03\x02\x02\x02\u01B1\u01B2\x03\x02\x02\x02\u01B2" +
		"\u01B4\x03\x02\x02\x02\u01B3\u01AD\x03\x02\x02\x02\u01B3\u01B4\x03\x02" +
		"\x02\x02\u01B4~\x03\x02\x02\x02\u01B5\u01B6\t\x06\x02\x02\u01B6\x80\x03" +
		"\x02\x02\x02\u01B7\u01BB\n\x07\x02\x02\u01B8\u01B9\x07^\x02\x02\u01B9" +
		"\u01BB\x05\x7F@\x02\u01BA\u01B7\x03\x02\x02\x02\u01BA\u01B8\x03\x02\x02" +
		"\x02\u01BB\x82\x03\x02\x02\x02\u01BC\u01C0\x07$\x02\x02\u01BD\u01BF\x05" +
		"\x81A\x02\u01BE\u01BD\x03\x02\x02\x02\u01BF\u01C2\x03\x02\x02\x02\u01C0" +
		"\u01BE\x03\x02\x02\x02\u01C0\u01C1\x03\x02\x02\x02\u01C1\u01C3\x03\x02" +
		"\x02\x02\u01C2\u01C0\x03\x02\x02\x02\u01C3\u01C4\x07$\x02\x02\u01C4\x84" +
		"\x03\x02\x02\x02\u01C5\u01C6\x07)\x02\x02\u01C6\u01C7\x05\x81A\x02\u01C7" +
		"\u01C8\x07)\x02\x02\u01C8\x86\x03\x02\x02\x02\v\x02\xD2\xD6\u01A3\u01AB" +
		"\u01B1\u01B3\u01BA\u01C0\x03\b\x02\x02";
	public static __ATN: ATN;
	public static get _ATN(): ATN {
		if (!ManimLexer.__ATN) {
			ManimLexer.__ATN = new ATNDeserializer().deserialize(Utils.toCharArray(ManimLexer._serializedATN));
		}

		return ManimLexer.__ATN;
	}

}

